<template>
  <div>
    <button
      class="d-none"
      data-toggle="modal"
      data-target="#editServiceRoasterModal"
      ref="openEditModalService"
    ></button>
    <div
      class="modal fade"
      id="editServiceRoasterModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Edit Event Travel Arrangements
            </h5>
            <button
              type="button"
              class="close text-primary"
              data-dismiss="modal"
              aria-label="Close"
              ref="openEditModalServiceClose"
              @click="resetForm()"
            >
              <img src="../../../../assets/Svg/close.svg" alt="" />
            </button>
          </div>
          <div class="modal-body">
            <div class="toggle-content">
              <div>
                <h6 class="toogle-header">Do you need travel arrangements?</h6>
                <span class="toggle-text" v-if="travelStatus == true"
                  >Please select the services you need while attending the
                  event</span
                >
              </div>
              <toggle-button
                class="toggle"
                v-model="travelStatus"
                @change="getDivs"
                :value="false"
                :sync="true"
                :width="34"
                ref="toggleBtn"
              />
            </div>
            <div v-if="travelStatus == true">
              <div
                v-if="showServiceSelectionError"
                class="event-error image-error"
              >
                Please select at least one service
              </div>
              <div id="accordion">
                <div v-for="(select, index) in selections" :key="index">
                  <div :id="'heading' + index">
                    <h6
                      class="py-2 border-bottom mb-3 d-flex align-items-center justify-content-between"
                      data-toggle="collapse"
                      :data-target="'#collapse' + index"
                      aria-expanded="true"
                      :aria-controls="'collapse' + index"
                    >
                      <span>
                        {{ select.text }}
                      </span>
                      <toggle-button
                        class="custom-control-toggle"
                        :id="'customCheck' + select.value"
                        @change="getValue(select, $event)"
                        :width="34"
                        :value="select.isChecked"
                      />
                    </h6>
                  </div>

                  <div v-if="select.value === 'hotel'">
                    <div
                      :id="'collapse' + index"
                      class="collapse"
                      :class="{ show: select.isChecked }"
                      aria-labelledby="'heading' + index"
                      data-parent="#accordion"
                    >
                      <div class="row no-gutters">
                        <div class="col-12 col-sm-6 pr-sm-3">
                          <div class="form-group control-group">
                            <label for="startDateCheck">Start Date</label>
                            <span
                              class="label-type error event-error ml-2"
                              v-if="startDateError != ''"
                            >
                              Please select Start Date.
                            </span>
                            <div class="input-group date" id="startDateCheck">
                              <date-picker
                                :open="startDateOpen"
                                @close="startDateOpen = false"
                                :editable="false"
                                :clearable="false"
                                @click.native="startDateOpen = true"
                                v-model="startDate"
                                valueType="format"
                                format="MMM DD, YYYY"
                                @change="checkdate"
                                :class="{
                                  'is-invalid': $v.startDate.$error,
                                  'is-valid': !$v.startDate.$invalid,
                                }"
                                placeholder="Select start date"
                              >
                                <i slot="icon-calendar" class="cursor-pointer">
                                  <img
                                    src="../../../../assets/Svg/calendar.svg"
                                  />
                                </i>
                              </date-picker>
                            </div>
                          </div>
                        </div>

                        <!-- Replace End Date input section -->
                        <div class="col-12 col-sm-6 mt-2 mt-sm-0">
                          <div class="form-group">
                            <label for="endDateCheck">End Date</label>
                            <span
                              class="label-type error event-error ml-2"
                              v-if="endDateError != ''"
                            >
                              Please select End Date.
                            </span>
                            <span
                              class="label-type error event-error ml-2"
                              v-if="endDateErrorGreater != ''"
                            >
                              End Date should be greater than start date
                            </span>
                            <div class="input-group date" id="endDateCheck">
                              <date-picker
                                :open="endDateOpen"
                                @close="endDateOpen = false"
                                :editable="false"
                                :clearable="false"
                                @click.native="endDateOpen = true"
                                v-model="endDate"
                                valueType="format"
                                format="MMM DD, YYYY"
                                @change="checkdate"
                                :class="{
                                  'is-invalid': $v.endDate.$error,
                                  'is-valid': !$v.endDate.$invalid,
                                }"
                                placeholder="Select end date"
                              >
                                <i slot="icon-calendar" class="cursor-pointer">
                                  <img
                                    src="../../../../assets/Svg/calendar.svg"
                                  />
                                </i>
                              </date-picker>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12 col-sm-6">
                          <div class="product-actions">
                            <p>Adults</p>
                            <div
                              class="product-inc-dec d-flex align-items-center"
                            >
                              <div
                                class="product-decrement"
                                @click="adultdecrement()"
                              >
                                <img
                                  src="../../../../assets/images/minus.png"
                                  alt=""
                                />
                              </div>
                              <div class="product-value">
                                <span>{{ adultQuantity }}</span>
                              </div>
                              <div
                                class="product-increment"
                                @click="adultIncrement()"
                              >
                                <img
                                  src="../../../../assets/images/plus.png"
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-12 col-sm-6">
                          <div class="product-actions">
                            <p>Rooms</p>
                            <div class="product-inc-dec">
                              <div
                                class="product-decrement"
                                @click="roomdecrement()"
                              >
                                <img
                                  src="../../../../assets/images/minus.png"
                                  alt=""
                                />
                              </div>
                              <div class="product-value">
                                <span>{{ room_count }}</span>
                              </div>
                              <div
                                class="product-increment"
                                @click="roomIncrement()"
                              >
                                <img
                                  src="../../../../assets/images/plus.png"
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-12 notes-div mt-1">
                          <div class="form-group">
                            <textarea
                              type="text"
                              class="form-control"
                              id="note"
                              rows="4"
                              :class="{
                                filled: note,
                                'is-invalid': $v.note.$error,
                                'is-valid': !$v.note.$invalid,
                              }"
                              v-model.trim="$v.note.$model"
                              @input="enableUpdateButton"
                              required
                            ></textarea>
                            <span class="placeholder">Notes</span>
                            <div
                              v-if="!$v.note.required && validationserror"
                              class="invalid-tooltip"
                            >
                              Notes is required
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="modal-footer"> -->
          <div class="event-btns-wrapper justify-content-end pt-3">
            <button
              type="button"
              class="btn btn-primary"
              @click="getServices(0)"
              :disabled="isLoadingArray[0]"
            >
              <div v-if="isLoadingArray[0]" class="lds-dual-ring"></div>
              <span v-else>
                <img src="../../../../assets/Svg/save.svg" alt="save">
                Update</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import $ from "jquery";
export default {
  name: "EditServicesModal",
  data() {
    return {
      startDateOpen: false,
      endDateOpen: false,
      selections: [
        { value: "hotel", text: "Hotel" },
        { value: "bnb", text: "Bnb" },
        { value: "car_rental", text: "Car Rental" },
        { value: "airline_tickets", text: "Airline Tickets" },
      ],
      toggleData: "",
      selectedArray: [],
      isDisabledServices: true,
      isLoadingArray: [],
      showRoomInput: false,
      travelStatus: false,
      exactRoomStartDate: "",
      exactRoomEndDate: "",
      startDate: "",
      endDate: "",
      startDateError: "",
      endDateError: "",
      endDateErrorGreater: "",
      exactStartDateformat: "",
      exactEndDateformat: "",
      room_count: 1,
      adultQuantity: 1,
      note: "",
      validationserror: false,
      serviceString: "",
      user_id: "",
      showServiceSelectionError: false,
    };
  },
  validations: {
    startDate: { required },
    endDate: { required },
    note: { required },
  },

  methods: {
    //   syncSelectionsFromArray() {
    //   this.selections.forEach((select) => {
    //     const isChecked = this.selectedArray.includes(select.text);
    //     this.$set(select, "isChecked", isChecked);
    //   });
    //   // Sync other dependent data
    //   this.toogleData = [...this.selectedArray];
    //   this.travelStatus = this.selectedArray.length > 0;
    //   this.isDisabledServices = this.selectedArray.length === 0;
    // },
    resetForm() {
      this.travelStatus = false;
      this.note = "";
      this.validationserror = false;
      this.$v.$reset();
      this.validationserror = false;
      this.endDateError = "";
      this.startDateError = "";

      this.selections.forEach((select) => {
        this.$set(select, "isChecked", false);
      });

      this.showRoomInput = false;
      this.selectedArray = [];
      this.toogleData = [];
      $("#servicesBtn").prop("disabled", true);
      this.isDisabledServices = true;
    },
    checkdate: function() {
      console.log("checkdate called with:", this.startDate, this.endDate);

      const month = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "July",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      // Helper function to convert date picker format to Date object
      const convertDatePickerToDate = (dateStr) => {
        if (!dateStr) return null;
        // If it's already in YYYY-MM-DD format, convert directly
        if (dateStr.includes("-") && dateStr.length === 10) {
          return new Date(dateStr);
        }
        // If it's in MMM DD, YYYY format from date picker
        const parts = dateStr.split(" ");
        if (parts.length === 3) {
          const monthName = parts[0];
          const day = parseInt(parts[1].replace(",", ""));
          const year = parseInt(parts[2]);
          const monthIndex = month.indexOf(monthName);
          if (monthIndex !== -1) {
            return new Date(year, monthIndex, day);
          }
        }
        return new Date(dateStr);
      };

      // Start Date
      if (this.startDate) {
        const startDateConvert = convertDatePickerToDate(this.startDate);
        this.exactStartDateformat = startDateConvert;

        if (startDateConvert && !isNaN(startDateConvert.getTime())) {
          const startMonth = startDateConvert.getMonth();
          const startDay = startDateConvert.getDate();
          const startYear = startDateConvert.getFullYear();
          this.exactRoomStartDate =
            month[startMonth] + " " + startDay + ", " + startYear;
          this.startDateError = "";
        } else {
          this.startDateError = "on";
        }
      }

      // End Date
      if (this.endDate) {
        const endDateConvert = convertDatePickerToDate(this.endDate);
        const startDateConvert = convertDatePickerToDate(this.startDate);

        if (endDateConvert && !isNaN(endDateConvert.getTime())) {
          if (startDateConvert && endDateConvert < startDateConvert) {
            this.endDateError = "";
            this.endDateErrorGreater = "on";
            this.exactRoomEndDate = "";
            this.isDisabledServices = true;
          } else {
            this.exactEndDateformat = endDateConvert;
            this.endDateError = "";
            this.endDateErrorGreater = "";
            this.isDisabledServices = false;

            const endMonth = endDateConvert.getMonth();
            const endDay = endDateConvert.getDate();
            const endYear = endDateConvert.getFullYear();
            this.exactRoomEndDate =
              month[endMonth] + " " + endDay + ", " + endYear;
          }
        } else {
          this.endDateError = "on";
        }
      }
    },
    roomIncrement() {
      this.room_count = parseInt(this.room_count, 10) + 1;
      this.isDisabledServices = false;
    },
    roomdecrement() {
      var newQuantity = this.room_count - 1;

      if (newQuantity > 0) {
        this.room_count = this.room_count - 1;
        this.isDisabledServices = false;
      }
    },
    adultIncrement() {
      this.adultQuantity = parseInt(this.adultQuantity, 10) + 1;
      this.isDisabledServices = false;
    },
    adultdecrement() {
      var newQuantity = this.adultQuantity - 1;

      if (newQuantity > 0) {
        this.adultQuantity = this.adultQuantity - 1;
        this.isDisabledServices = false;
      }
    },
    enableUpdateButton() {
      this.isDisabledServices = false;
    },
    getDivs() {
      const onlyHotelSelected =
        this.selectedArray.length === 1 && this.selectedArray[0] === "Hotel";

      if (onlyHotelSelected) {
        this.showRoomInput = true;
      } else {
        this.showRoomInput = false;
      }
      if (this.travelStatus == false) {
        this.selectedArray = [];
        this.showRoomInput = false;
        this.room_count = 1;
        this.travelStatus = false;
        this.adultQuantity = 1;
        this.note = "";
        this.exactStartDateformat = "";
        $("#servicesBtn").prop("disabled", false);
        this.isDisabledServices = false;
      }
      if (
        (!this.selectedArray || this.selectedArray.length === 0) &&
        this.travelStatus == true
      ) {
        $("#servicesBtn").prop("disabled", true);
        this.isDisabledServices = true;
      } else {
        $("#servicesBtn").prop("disabled", false);
        this.isDisabledServices = false;
      }
    },
    getValue(select, event) {
      const index = this.selections.findIndex(
        (item) => item.value === select.value
      );

      if (event.value === true) {
        if (select.value === "hotel") {
          this.showRoomInput = true;
        }
        this.$set(this.selections[index], "isChecked", true);
      } else {
        if (select.value === "hotel") {
          this.showRoomInput = false;
        }
        this.$set(this.selections[index], "isChecked", false);
      }

      this.selectedArray = this.selections
        .filter((item) => item.isChecked)
        .map((item) => item.text);
      this.toogleData = this.selectedArray;
      let anySelectionTrue = this.selections.some((item) => item.isChecked);
      this.travelStatus = anySelectionTrue;

      if (this.selectedArray.length === 0) {
        $("#servicesBtn").prop("disabled", true);
        this.isDisabledServices = true;
      } else {
        $("#servicesBtn").prop("disabled", false);
        this.isDisabledServices = false;
      }
      this.showServiceSelectionError = false;
    },
    validationStatus: function(validation) {
      return typeof validation != "undefined" ? validation.$error : false;
    },
    getServices(index) {
      this.showServiceSelectionError = false;
      if (this.travelStatus === true) {
        if (this.selectedArray.length === 0) {
          this.showServiceSelectionError = true;
          return;
        }
        if (this.showRoomInput) {
          this.startDateError = !this.startDate ? "on" : "";
          this.endDateError = !this.endDate ? "on" : "";
        }

        const cleanSelectedArray = [...this.selectedArray];
        const cleanServicesString = cleanSelectedArray.join(",");

        console.log("Selected Array:", cleanSelectedArray);
        console.log("Services String:", cleanServicesString);

        if (cleanSelectedArray.length === 0) {
          $("#servicesBtn").prop("disabled", true);
          this.isDisabledServices = true;
        } else {
          $("#servicesBtn").prop("disabled", false);
          this.isDisabledServices = false;
          this.$set(this.isLoadingArray, index, false);

          if (this.showRoomInput === true) {
            this.validationserror = true;
            this.$v.$touch();

            if (this.$v.$pending || this.$v.$error) return;

            this.checkdate();

            this.$root.$emit(
              "dataForservice",
              cleanServicesString,
              this.user_id,
              this.room_count,
              this.adultQuantity,
              this.note,
              this.exactRoomStartDate,
              this.exactRoomEndDate
            );

            this.$root.$emit(
              "attendeesData",
              cleanServicesString,
              this.user_id,
              this.room_count,
              this.adultQuantity,
              this.note,
              this.exactRoomStartDate,
              this.exactRoomEndDate
            );
          } else {
            this.$root.$emit(
              "dataForservice",
              cleanServicesString,
              this.user_id,
              "",
              "",
              "",
              "",
              ""
            );
            this.$root.$emit(
              "attendeesData",
              cleanServicesString,
              this.user_id,
              "",
              "",
              "",
              "",
              ""
            );
          }
        }
      } else {
        this.$root.$emit("dataForservice", "", "", "", "", "", "");
        this.$root.$emit("attendeesData", "", "", "", "", "", "");
      }

      // Reset modal and fields
      const elem = this.$refs.openEditModalServiceClose;
      if (elem) elem.click();

      this.selectedArray = [];
      this.room_count = 1;
      this.travelStatus = false;
      this.adultQuantity = 1;
      this.note = "";
      this.exactStartDateformat = "";
      this.startDate = "";
      this.endDate = "";

      this.selections = [
        { value: "hotel", text: "Hotel" },
        { value: "bnb", text: "Bnb" },
        { value: "car_rental", text: "Car Rental" },
        { value: "airline_tickets", text: "Airline Tickets" },
      ];

      $("#servicesBtn").prop("disabled", true);
      this.isDisabledServices = true;
    },
    convertToDatePickerFormat(dateString) {
      if (!dateString) return "";

      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      // Match 3-letter month format e.g., "Apr 2, 2025"
      const shortMonthMatch = dateString.match(
        /^([A-Za-z]{3}) (\d{1,2}), (\d{4})$/
      );
      if (shortMonthMatch) {
        const [, month, day, year] = shortMonthMatch;
        const paddedDay = day.padStart(2, "0");
        return `${month} ${paddedDay}, ${year}`;
      }

      // Match full month format e.g., "April 2, 2025"
      const fullMonthMatch = dateString.match(
        /^([A-Za-z]{4,}) (\d{1,2}), (\d{4})$/
      );
      if (fullMonthMatch) {
        const [, fullMonth, day, year] = fullMonthMatch;
        const paddedDay = day.padStart(2, "0");
        const shortMonth =
          months.find((m) => fullMonth.startsWith(m)) || fullMonth.slice(0, 3);
        return `${shortMonth} ${paddedDay}, ${year}`;
      }

      // Match ISO format e.g., "2025-04-02"
      const isoMatch = dateString.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (isoMatch) {
        const [, year, month, day] = isoMatch;
        const shortMonth = months[parseInt(month) - 1];
        return `${shortMonth} ${day}, ${year}`;
      }

      return ""; // Fallback
    },
    getParseServices(servicesString, services) {
      const servicesArray = servicesString.split(",");
      this.selectedArray = [...servicesArray]; // ✅ Set clean array
      console.log("Selected Array:", this.selectedArray);

      // const hasBnb = servicesArray.includes("Bnb");
      // const hasCarRental = servicesArray.includes("Car Rental");
      // const hasAirlineTickets = servicesArray.includes("Airline Tickets");
      const hotelService = servicesArray.find((service) =>
        service.includes("Hotel")
      );
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      const normalizeMonth = (monthStr) => {
        const fullToAbbrev = {
          January: "Jan",
          February: "Feb",
          March: "Mar",
          April: "Apr",
          May: "May",
          June: "Jun",
          July: "Jul",
          August: "Aug",
          September: "Sep",
          October: "Oct",
          November: "Nov",
          December: "Dec",
        };

        const lower = monthStr.toLowerCase();
        const match = Object.keys(fullToAbbrev).find((key) =>
          key.toLowerCase().startsWith(lower)
        );
        return match ? fullToAbbrev[match] : monthStr.slice(0, 3);
      };

      const parseDate = (dateString, fallbackYear) => {
        if (!dateString) return "";

        const isoMatch = dateString.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (isoMatch) {
          const [, year, month, day] = isoMatch;
          const shortMonth = months[parseInt(month) - 1];
          return `${shortMonth} ${day.padStart(2, "0")}, ${year}`;
        }

        const parts = dateString.split(/[\s,]+/).filter(Boolean);
        if (parts.length < 2) return "";

        let month = normalizeMonth(parts[0]);
        const day = parts[1].padStart(2, "0");
        const year = parts[2] || fallbackYear || new Date().getFullYear();

        return `${month} ${day}, ${year}`;
      };

      // Usage
      if (hotelService && hotelService.includes("(")) {
        const dates = hotelService.match(/\(([^)]+)\)/)[1].split(" - ");
        const [start, end] = dates.map((date) => date.trim());
        const endDateYear = parseDate(end).split(" ")[2];
        this.startDate = parseDate(start, endDateYear);
        this.endDate = parseDate(end);
        console.log("Parsed Start Date:", this.startDate);
        console.log("Parsed End Date:", this.endDate);
        this.checkdate();
      } else if (services.exactStartDate && services.exactEndDate) {
        const endDateYear = parseDate(services.exactEndDate).split(" ")[2];
        this.startDate = parseDate(services.exactStartDate, endDateYear);
        this.endDate = parseDate(services.exactEndDate);
        console.log("Parsed Start Date 2:", this.startDate);
        console.log("Parsed End Date 2:", this.endDate);
        this.checkdate();
      }

      this.selections.forEach((select) => {
        const selected = servicesArray.includes(select.text);
        this.$set(select, "isChecked", selected);
        if (selected && select.value === "hotel") {
          this.showRoomInput = true;
        }
      });

      const elem = this.$refs.openEditModalService;
      if (elem) {
        elem.click();
        this.validationserror = false;
        this.room_count = services.room_count || 1;
        this.adultQuantity = services.adult_count || 1;
        this.note = services.note || "";
        this.exactRoomStartDate = this.exactStartDate || "";
        this.exactRoomEndDate = this.exactEndDate || "";
        this.travelStatus = true;

        if (this.travelStatus === true) {
          $("#servicesBtn").prop("disabled", true);
          this.isDisabledServices = true;
        } else {
          $("#servicesBtn").prop("disabled", false);
          this.isDisabledServices = false;
        }
      }
    },
  },
  mounted() {
    let clickedInside = false;
    const self = this; // Store Vue component instance reference

    $("#editServiceRoasterModal .modal-content").on("click", function() {
      clickedInside = true;
    });

    $("#editServiceRoasterModal").on("click", function() {
      if (!clickedInside) {
        self.resetForm(); // Use 'self' instead of 'this'
      }
      clickedInside = false;
    });

    this.$root.$on("openEditServicesModal", (data) => {
      var elem = this.$refs.openEditModalService;
      if (elem) {
        elem.click();
        if (this.travelStatus == true) {
          $("#servicesBtn").prop("disabled");
          this.isDisabledServices = true;
        } else {
          $("#servicesBtn").prop("disabled", false);
          this.isDisabledServices = false;
        }
        if (data) {
          console.log("Data received in EditServicesModal23:", data);
          this.user_id = data.member_id;
          const event = data.event;

          this.startDate = this.convertToDatePickerFormat(
            event.startDateForField
          );
          this.endDate = this.convertToDatePickerFormat(event.endDateForField);

          // Add these nextTick calls to ensure Vue updates the DOM
          this.$nextTick(() => {
            this.checkdate();
            const services = data.services;
            this.servicesString = data.services.services;
            this.selectedArray = data.services.services;
            if (this.selectedArray && this.selectedArray.length > 0) {
              this.getParseServices(this.selectedArray, services);
              this.travelStatus = true;
            } else {
              this.startDate = this.convertToDatePickerFormat(
                event.exactStartDate
              );
              this.endDate = this.convertToDatePickerFormat(event.exactEndDate);
            }
          });
        }
        console.log("Start:", this.startDate);
        console.log("End", this.endDate);
      }
    });
  },
};
</script>

<style>
.custom-checkbox {
  border-bottom: 1px solid #cfd7e0;
  padding: 16px 0;
}
.custom-checkbox:last-child {
  border: none;
  padding-bottom: 0;
}
.custom-checkbox .custom-control-label::before {
  display: none !important;
}
.custom-control {
  padding-left: 0 !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
#startDate {
  position: relative;
}
.vue-js-switch {
  margin-bottom: 0;
}

.product-decrement {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* .form-control.is-invalid {
    background-image: none !important;
  } */
</style>
